import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=b8e8253e&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=b8e8253e&prod&lang=scss"
import style1 from "./Setting.vue?vue&type=style&index=1&id=b8e8253e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e8253e",
  null
  
)

export default component.exports